import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BookOpen, ChevronDown } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";
import { CodeBlock } from "./CodeBlock";

const STEPS = ["step1", "step2", "step3", "step4", "step5"];

export const IntegrationGuide = ({ baseUrl }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);

  const pull = `curl -H "X-Api-Key: ahk_live_xxx" \\
  "${baseUrl}/api/v1/public/attendance?date_from=2026-06-01&date_to=2026-06-30"`;

  const hours = `curl -H "X-Api-Key: ahk_live_xxx" \\
  "${baseUrl}/api/v1/public/worked-hours?month=2026-06"`;

  const hook = `POST https://erp.example.com/hooks/helcoo
X-HELCOO-Signature: <hmac_sha256(secret, raw_body)>

{ "event": "attendance.checked_out",
  "data": { "user_id": "...", "branch_id": "...",
            "checked_out_at": "2026-06-01T14:03:11Z",
            "worked_minutes": 486, "late_minutes": 0 } }`;

  return (
    <NeuCard data-testid="integration-guide">
      <button
        type="button"
        data-testid="integration-guide-toggle"
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between gap-3"
      >
        <span className="label-xs flex items-center gap-2">
          <BookOpen className="h-4 w-4 text-primary" /> {t("api.guide.title")}
        </span>
        <ChevronDown className={`h-4 w-4 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>

      {open ? (
        <div className="mt-4 space-y-5">
          <p className="text-sm text-muted-foreground">{t("api.guide.intro")}</p>

          <ol className="space-y-3">
            {STEPS.map((key, i) => (
              <li key={key} className="flex gap-3 rounded-2xl border border-border/50 p-4 shadow-neu-sm">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary/15 font-mono text-xs font-bold text-primary">
                  {i + 1}
                </span>
                <div>
                  <p className="text-sm font-bold">{t(`api.guide.${key}.title`)}</p>
                  <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{t(`api.guide.${key}.body`)}</p>
                </div>
              </li>
            ))}
          </ol>

          <CodeBlock label={t("api.guide.pullLabel")} code={pull} testId="guide-code-pull" />
          <CodeBlock label={t("api.guide.hoursLabel")} code={hours} testId="guide-code-hours" />
          <CodeBlock label={t("api.guide.hookLabel")} code={hook} testId="guide-code-hook" />

          <p className="text-xs leading-relaxed text-muted-foreground">{t("api.guide.security")}</p>
        </div>
      ) : null}
    </NeuCard>
  );
};
